/* 
Object:         NAW
Description:    Logic and events for the module NAW / Adres
Used in:        Adres
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";
import * as googlemaps          from "../googlemaps";
import * as navigation          from "../navigation";
import * as viewmode            from "../viewmode";

/**
* Init (binding button actions) Overview Adres
*/
export function initialize(): void {
    // Create new record ...
    $("#editNaw").on("click", function (e: JQuery.Event) {

        // Prevent default behaviour
        e.preventDefault();

        // Edit mode form
        viewmode.setViewMode(ModuleActionViewEnum.Edit);

        // Load create form into the current module div 
        navigation.navigateToSpecificUrl("NAW/Edit");
    });
}


/**
* Init Form Adres 
* @param {any} googleMapsApiKey
*/
export function initializeForm(googleMapsApiKey: string): void {
    // Create new record ...
    $("#updateLocation").on("click", function (e: JQuery.Event): void {

        // Prevent default behaviour
        e.preventDefault();

        // Get all input values
        const country = $("#CountryID").data("kendoDropDownList").text();
        const street = $('#Street').data("kendoTextBox").value();
        const number = $('#Number').data("kendoTextBox").value();
        const zip = $('#Zip').data("kendoTextBox").value();
        const city = $('#City').data("kendoTextBox").value();

        // Construct address to send
        let address = '';

        if (country.length > 0) {
            address += country + ',';
        }
        if (street.length > 0) {
            address += street + ' ';
        }
        if (number.length > 0) {
            address += number + ',';
        }
        if (zip.length > 0) {
            address += zip + ',';
        }
        if (city.length > 0) {
            address += city + ',';
        }

        // Google Maps API key
        googlemaps.updateLonitudeLatitude(googleMapsApiKey, address);
    });
}
